// src/pages/Accessibility.jsx
import React from "react";
import { Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Accessibility = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        backgroundImage: `url(${require("../assets/images/landing_background.jpg")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        fontFamily: "'Baloo Bhaijaan 2', cursive",
        color: "white",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <header
        style={{
          width: "100%",
          padding: "10px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.5)",
        }}
      >
        <img
          src={require("../assets/images/logo_name.PNG")}
          alt="YourStoryWorld Logo"
          style={{ height: "40px", cursor: "pointer" }}
          onClick={() => navigate("/")}
        />
        <div>
          <Button color="inherit" onClick={() => navigate("/")}>
            Home
          </Button>
          <Button color="inherit" onClick={() => navigate("/login")}>
            Sign In
          </Button>
          <Button color="inherit" onClick={() => navigate("/help")}>
            Help
          </Button>
        </div>
      </header>

      {/* Content */}
      <Container
        maxWidth="md"
        style={{
          marginTop: "30px",
          marginBottom: "30px",
          background: "rgba(255, 255, 255, 0.97)",
          borderRadius: "10px",
          padding: "30px 20px",
          color: "#333",
        }}
      >
        <Typography variant="h4" gutterBottom>
          Accessibility Statement
        </Typography>
        <Typography variant="subtitle2" gutterBottom>
          Last Updated: January 2026
        </Typography>
        <Typography variant="body2" paragraph>
          YourStoryWorld Ltd (Company No.
          17098564), United Kingdom. We want as many people as possible to be
          able to use our platform, including children and adults with
          disabilities or additional needs.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Our approach
        </Typography>
        <Typography variant="body2" paragraph>
          We aim to design with accessibility in mind from the start. This
          includes:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">
              Clear typography and simple layouts.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              High-contrast text where possible and sufficient text size for
              reading.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Support for keyboard navigation on key screens.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Accessible labels for important buttons and controls.
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2. Features that may help
        </Typography>
        <Typography variant="body2" paragraph>
          Some features can support users with different needs:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">
              <strong>Text-to-speech:</strong> stories can be listened to as
              audio, which may support readers with dyslexia or visual
              impairments.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              <strong>Phonics mode:</strong> helps younger or early readers by
              simplifying words and focusing on sound patterns.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              <strong>Adjustable story length and difficulty:</strong> adults
              can choose suitable settings for each child.
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          3. Where we are still improving
        </Typography>
        <Typography variant="body2" paragraph>
          We know there is more we can do. For example, we are actively working
          toward:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">
              Improving keyboard navigation on all pages.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Enhancing compatibility with screen readers.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Providing clearer guidance for colour contrast and visual
              overload, especially for neurodivergent learners.
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          4. What you can do
        </Typography>
        <Typography variant="body2" paragraph>
          You may be able to further improve your experience by:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">
              Adjusting system-level accessibility settings on your device (such
              as text size, high contrast mode or screen reader).
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Using browser extensions that support reading, such as text-to-speech
              tools or overlays.
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          5. Feedback & contact
        </Typography>
        <Typography variant="body2" paragraph>
          If you have difficulty using any part of YourStoryWorld, or have
          suggestions for how we can make it more accessible, please contact:
          <br />
          <strong>support@yourstoryworld.com</strong>
        </Typography>
        <Typography variant="body2" paragraph>
          Please include as much detail as you can (for example, the page you
          were on, the device you were using, and what you were trying to do) so
          we can investigate and improve.
        </Typography>
      </Container>
    </div>
  );
};

export default Accessibility;
